import abi from './abi'
import {ethers} from 'ethers'
import addresses from './contractAddresses'

const rpcEndPoint = {
    main: 'https://polygon-rpc.com/'
}

const ethersProvider = new ethers.providers.JsonRpcProvider(rpcEndPoint.main)
ethersProvider.on("network", (newNetwork, oldNetwork) => {
        if (oldNetwork) {
            window.location.reload();
        }
});

const yieldTokenAddress = addresses.yieldToken
const USDCAddress = addresses.USDC
const accessTokenAddress = addresses.accessToken
const yieldSaleAddress = addresses.yieldSale
const batchYieldAddress = addresses.batchYield

const yieldTokenContract = new ethers.Contract(yieldTokenAddress, abi.yieldToken, ethersProvider)
const USDCContract = new ethers.Contract(USDCAddress, abi.USDC, ethersProvider)
const accessTokenContract = new ethers.Contract(accessTokenAddress, abi.accessToken, ethersProvider)
const yieldSaleContract = new ethers.Contract(yieldSaleAddress, abi.yieldSale, ethersProvider)
const batchYieldContract = new ethers.Contract(batchYieldAddress, abi.batchYield, ethersProvider)

let abis = {}
abis[yieldTokenAddress] = abi.yieldToken
abis[USDCAddress] = abi.USDC
abis[accessTokenAddress] = abi.AccessToken
abis[yieldSaleAddress] = abi.yieldSale
abis[batchYieldAddress] = abi.batchYield

const confirm = (txhash) => {
    return new Promise(r=>ethersProvider.once(txhash,()=>r()))
}

const send = async (address, provider, func, params) => {
    console.log('address: ' + address)
    console.log(func)
    console.log(params)
    const contract = new ethers.Contract(address, abis[address], provider)
    let ret
    try{
        
        ret = await contract[func](...params)
    }
    catch(e){
        console.log(e)
        return e
    }
    return ret
}

const $ = {
    provider: ethersProvider,
    confirm,
    nativeBalanceOf: async (acc) => {
        let wallet = new ethers.Wallet(acc.privateKey,ethersProvider)
        return await wallet.getBalance()
    },
    yieldToken: {
       address: yieldTokenAddress,
       balanceOf: async (account) => await yieldTokenContract.balanceOf(account),
       tokenOfOwnerByIndex: async (owner, idx) => await yieldTokenContract.tokenOfOwnerByIndex(owner, idx),
       tokenURI: async (tokenId) => await yieldTokenContract.tokenURI(tokenId),
       owner: async () => await yieldTokenContract.owner(),
       ownerOf: async (tokenId) => await yieldTokenContract.ownerOf(tokenId),
       isApprovedForAll: async (owner, operator) => await yieldTokenContract.isApprovedForAll(owner, operator),
       yieldBalance: async(provider, tokenId) => {
           const contract = new ethers.Contract(yieldTokenAddress, abis[yieldTokenAddress], provider)
           return await contract.yieldBalance(tokenId)
       },
       setApprovalForAll: async (provider, operator, approved) => await send(yieldTokenAddress, provider, 'setApprovalForAll', [operator, approved]),
       transferFrom: async (provider, from, to, tokenId) => await send(yieldTokenAddress,provider,'transferFrom',[from, to, tokenId]),
       //allowance: async (owner, spender) => await sgtUSDCContract.allowance(owner,spender),
       //approve: async (provider, spender, amount) => await send(sgtUSDCAddress, provider, 'approve',[spender,amount]),
       withdraw: async (provider, tokenId) => await send(yieldTokenAddress, provider, 'withdraw', [tokenId]),
       purchaseTransfer: async (provider, tokenId, to) => await send(yieldTokenAddress, provider,'purchaseTransfer',[tokenId, to])
    },
    USDC: {
        address: USDCAddress,
        allowance: async (owner, spender) => await USDCContract.allowance(owner,spender),
        balanceOf: async (address) => await USDCContract.balanceOf(address),
        decimals: async () => await USDCContract.decimals(),
        name: async () => await USDCContract.name(),
        symbol: async () => await USDCContract.symbol(),
        approve: async (provider, spender, amount) => await send(USDCAddress, provider, 'approve',[spender,amount]),
        test: {
            mint: async (provider, to, amount) => await send(USDCAddress, provider, 'mint',[to, amount]),
        }
    },
    accessToken: {
        balanceOf: async (address) => await accessTokenContract.balanceOf(address)
    },
    yieldSale: {
        address: yieldSaleAddress,
        isAdmin: async (account) => await yieldSaleContract.isAdmin(account),
        owner: async() => await yieldSaleContract.owner(),
        numAvailable: async (url) => await yieldSaleContract.numAvailable(url),
        getPrice: async (tokenId) => await yieldSaleContract.getPrice(tokenId),
        setAdmin: async (provider, account, isAdmin) => await send(yieldSaleAddress, provider, 'setAdmin', [account, isAdmin]),
        setBasePrice: async (provider, basePrice) => await send(yieldSaleAddress, provider, 'setBasePrice', [basePrice]),
        setAvailable: async (provider, url, available) => await send(yieldSaleAddress, provider, 'setAvailable', [url, available]),
        initialize: async (provider, url, level, available) => await send(yieldSaleAddress, provider, 'initialize', [url, level, available]),
        buy: async (provider, tokenId) => await send(yieldSaleAddress, provider, 'buy', [tokenId])
    },
    batchYield: {
        address: batchYieldAddress,
        getYield: async (account) => await batchYieldContract.getYield(account),
        withdraw: async (provider, account) => await send(batchYieldAddress, provider, 'withdraw', [account])
    }
}

export default $

